const pluralizer = (count: number, singular: string, plural: string) => {
	return count === 1 ? singular : plural;
};

export default pluralizer;
